import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { selectConfig } from '../utils/configUtils.js';

const ConfigContext = createContext({
    config: {},
});
const useConfig = () => useContext(ConfigContext);
const ConfigProvider = ({ env, children, shopBundle }) => {
    const config = selectConfig(env)(shopBundle);
    return jsx(ConfigContext.Provider, { value: { config }, children: children });
};

export { ConfigProvider as default, useConfig };
//# sourceMappingURL=ConfigProvider.js.map
